import React from "react";
import "./NoMatch.css"; // Import your loading spinner CSS for styling

const NoMatch = () => {

  return (
    <div className="noMatch-container">
      <div>
        <div className="">
          <p className="" style={{
            fontFamily: "Montserrat, Poppins, sans-serif",
            fontWeight: "bold",
          }}>NO UPCOMING EVENTS WITH CURRENT FILTERS</p>
        </div>
      </div>
    </div>
  );
};

export default NoMatch;